import { mdlBoardListRequest } from "../models/service-models/board/BoardListRequest";
import { mdlBoardListResponse } from "../models/service-models/board/BoardListResponse";
import { mdlServiceResponse } from "../models/service-models/common/ServiceResponse";
import { mdlBoardCreateRequest } from "../models/service-models/board/BoardCreateRequest";
import { mdlBoardCreateResponse } from "../models/service-models/board/BoardCreateResponse";
import { mdlBoardDeleteRequest } from "../models/service-models/board/BoardDeleteRequest";
import { mdlBoardDeleteResponse } from "../models/service-models/board/BoardDeleteResponse";
import { mdlBoardDetailRequest } from "../models/service-models/board/BoardDetailRequest";
import { mdlBoardDetailResponse } from "../models/service-models/board/BoardDetailResponse";
import { mdlBoardUpdateRequest } from "../models/service-models/board/BoardUpdateRequest";
import { mdlBoardUpdateResponse } from "../models/service-models/board/BoardUpdateResponse";
import { GetResponse } from "../utils/ApiClient";
import { mdlSystemBoardListRequest } from "../models/service-models/board/SystemBoardListRequest";
import { mdlSystemBoardListResponse } from "../models/service-models/board/SystemBoardListResponse";
import { mdlCopyBoardsToOtherHotelsRequest } from "../models/service-models/board/CopyBoardsToOtherHotelsRequest";
import { mdlCopyBoardsToOtherHotelsResponse } from "../models/service-models/board/CopyBoardsToOtherHotelsResponse";
import { mdlBaseHotelIdRequest } from "../models/service-models/common/BaseHotelIdRequest";
import { mdlBaseDataResponse } from "../models/service-models/common/BaseDataResponse";
import { mdlBaseDropdownResponse } from "../models/service-models/common/BaseDropdownResponse";

module BoardService {
    export async function Create(
        pRequest: mdlBoardCreateRequest
    ): Promise<mdlServiceResponse<mdlBoardCreateResponse>> {
        return await GetResponse<mdlServiceResponse<mdlBoardCreateResponse>>(
            "board/create",
            pRequest
        );
    }

    export async function Update(
        pRequest: mdlBoardUpdateRequest
    ): Promise<mdlServiceResponse<mdlBoardUpdateResponse>> {
        return await GetResponse<mdlServiceResponse<mdlBoardUpdateResponse>>(
            "board/update",
            pRequest
        );
    }

    export async function Delete(
        pRequest: mdlBoardDeleteRequest
    ): Promise<mdlServiceResponse<mdlBoardDeleteResponse>> {
        return await GetResponse<mdlServiceResponse<mdlBoardDeleteResponse>>(
            "board/delete",
            pRequest
        );
    }

    export async function List(
        pRequest: mdlBoardListRequest
    ): Promise<mdlServiceResponse<mdlBoardListResponse>> {
        return await GetResponse<mdlServiceResponse<mdlBoardListResponse>>(
            "board/list",
            pRequest
        );
    }

    export async function Detail(
        pRequest: mdlBoardDetailRequest
    ): Promise<mdlServiceResponse<mdlBoardDetailResponse>> {
        return await GetResponse<mdlServiceResponse<mdlBoardDetailResponse>>(
            "board/detail",
            pRequest
        );
    }
    export async function SystemBoardList(
        pRequest: mdlSystemBoardListRequest
    ): Promise<mdlServiceResponse<mdlSystemBoardListResponse>> {
        return await GetResponse<mdlServiceResponse<mdlSystemBoardListResponse>>(
            "board/system-board-list",
            pRequest
        );
    }
    export async function CopyBoardsToOtherHotels(
        pRequest: mdlCopyBoardsToOtherHotelsRequest
    ): Promise<mdlServiceResponse<mdlCopyBoardsToOtherHotelsResponse>> {
        return await GetResponse<mdlServiceResponse<mdlCopyBoardsToOtherHotelsResponse>>(
            "board/copy-boards-to-other-hotels",
            pRequest
        );
    }

    export async function BoardNameList(
        pRequest: mdlBaseHotelIdRequest
    ): Promise<mdlServiceResponse<mdlBaseDataResponse<Array<mdlBaseDropdownResponse>>>> {
        return await GetResponse<mdlServiceResponse<mdlBaseDataResponse<Array<mdlBaseDropdownResponse>>>>(
            "board/get-board-names",
            pRequest
        );
    }


}
export { BoardService };
